
































import { Component, Vue, Prop } from 'vue-property-decorator';
import { Actions } from '@/ts/store/Constants';

@Component({
    name: 'EventCardActions',
})
export default class EventCardActions extends Vue {
    @Prop({ required: true }) public attending: boolean;
    @Prop({ required: true }) public eventId: number;

    public buttonState: boolean = false;

    constructor() {
        super();
    }

    public changeAttendingStatus(value: boolean) {
        if (value === this.attending) {
            return;
        }

        this.buttonState = true;
        const eventId = this.eventId;

        this.$store.dispatch(Actions.POST_USER_ATTENDING_CALENDAR_EVENT, {
            eventId,
            attending: value,
        }).then(() => {
            this.buttonState = false;
            this.$emit('attendingStatusChanged', value);
        });
    }
}
